export default __webpack_public_path__ + "static/media/hero_waves.4a5a3caa.png";